<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1></h1>
<p style="text-align: center;"><strong>MAP OF THE MEDITERRANEAN BASIN AND THE ROMAN EMPIRE</strong></p>
<br/>
<p style="text-align: center;"><img alt="" src="media/file0.jpg" style="width:3.74097in;height:2.74722in"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?92b93338